import { Injectable } from '@angular/core';


export interface GoogleAnalyticsEvent {
  event: string;
  pagePath ?: string;
  pageTitle ?: string;
}

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() { }

  // Create our event emitter to send our data to Google Analytics

  public eventEmitter(
    eventDetails: GoogleAnalyticsEvent,
    isPageLoadEvent: boolean = false
  ) {
    
    if (isPageLoadEvent) {
      this.loadEvent();
    }
    window['aedataLayer'] = window['aedataLayer'] || [];
    window['aedataLayer'].push(eventDetails);
  }

  public loadEvent() {
    window['aedataLayer'].push({
      event: 'gtm.load'
    });
  }

}
